module.exports = __webpack_public_path__ + "static/media/img_Benchmarking401.5f147663.png";